import { render, staticRenderFns } from "./editbilling.vue?vue&type=template&id=f2fcb6e2&"
import script from "./editbilling.vue?vue&type=script&lang=ts&"
export * from "./editbilling.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports